const translations = {
  tj: {
    for_complete_request:
      'Барои ба охир расонидани дархост, сурати шиносномаро ворид кунед.',
    last_step: 'Қадами охирин монд',
    send_files: 'Равон кардан',
    reference: 'Маълумотномаи музди маошро ворид кунед',
    reference_visa: 'Ҳуҷҷати даромадро ворид кунед (Ихтиёрӣ)',
    new_pass: 'Пластикӣ',
    old_pass: 'Қоғазӣ',
    new_pass_back: 'Сурати паси шиносномаро ворид кунед',
    new_pass_front: 'Саҳифаи асосии шиносномаро ворид кунед',
    old_pass_front: 'Саҳифаи маълумоти шахсиро ворид кунед',
    old_pass_back: 'Саҳифаи ҷои зистро ворид кунед',
    inn: 'Саҳифаи РМА-ро ворид кунед',
    change_number: 'Ивази раками телефон',
    input_code: 'Рамзро ворид кунед',
    confirm_code: 'Подтвердить',
    sms_sent_to_number: 'Ба рақам SMS бо рамз фиристода шудааст',
    license: 'Иҷозатномаи БМТ №0000114 аз 03.01.2020.',
    alif_bank: 'ҶСК «Алиф Бонк»',
    next: 'Далее',
    select_passport_type: 'Намуди шиносномаро интихоб кунед',
    accept:
      'Бо зеркунии тугмаи «Далее», ман тасдиқ мекунам, ки ман коркарди маълумоти шахсии худро хондаам ва розӣ ҳастам',
    imput_phone:
      'Рақами телефонеро, ки аз он шумо ариза баромадаед, ворид кунед',
    upload_need_docs:
      'Барои баррасии минбаъдаи аризаи худ ҳуҷҷатҳои заруриро бор кунед.',
    back_to_main: 'Баргаштан ба саҳифаи асосӣ',
    upload_files: 'Ҳуҷҷатҳоятонро ворид кунед',
    request_accepted: 'Дархости шумо қабул шуд ва баррасӣ шуда истодаас',
    app_confirmation:
      'Пас аз баррасӣ, мо ҳатман натиҷаро гузориш хоҳем дод. Ташаккур',
    auto_request:
      'Мутахассисони мо ҳатман бо шумо тамос хоҳанд гирифт. Ташаккур',
    courier_delivery_card:
      'Корт дар муддати якчанд рӯз омода мешавад. Барои расонидани корт қосидамон ба шумо занг мезананд. Ташаккур',
    courier_delivery_card_visa:
      'Барои аниқ кардани суроға, қосидамон ба шумо занг мезанад. Ташаккур ',
    text: 'Текст tj',
  },
  ru: {
    for_complete_request:
      'Загрузите фото или скан паспорта для оканчания подачи заявки',

    last_step: 'Остался последний шаг',
    send_files: 'Отправить',
    reference: 'Загрузите справку о доходах',
    reference_visa: 'Загрузите справку о доходах (Необязательное поле)',
    new_pass: 'Пластиковый',
    old_pass: 'Бумажный',
    new_pass_back: 'Загрузите обратную сторону паспорта',
    new_pass_front: 'Загрузите переднюю сторону паспорта',
    old_pass_front: 'Загрузите cтраницу с персональными данными',
    old_pass_back: 'Загрузите страницу с пропиской',
    inn: 'Загрузите страницу с ИНН',
    change_number: 'Изменить номер',
    input_code: 'Введите код ',
    confirm_code: 'Подтвердить',
    sms_sent_to_number: 'SMS с кодом отправлен на номер',
    license: 'Лицензия НБТ №0000114 от 3 января 2020г.',
    alif_bank: 'ОАО «Алиф Банк»',
    next: 'Далее',
    select_passport_type: 'Выберите образец паспорта',
    accept:
      'Нажимая кнопку «Далее» я подтверждаю, что ознакомлен и согласен на обработку моих персональных данных',
    imput_phone: 'Введите номер телефона, с которого оставляли заявку',
    upload_need_docs:
      'Загрузите необходимые документы для дальнейшего рассмотрения вашей заявки.',
    request_accepted: 'Ваша заявка принята и рассматривается',
    back_to_main: 'Вернуться на главную',
    upload_files: 'Загрузите документы',
    app_confirmation:
      'После рассмотрения обязательно сообщим о результате. Спасибо ',
    auto_request: 'Наши специалисты обязательно с вами свяжутся. Спасибо ',
    courier_delivery_card:
      'Карта будет готова в течение нескольких дней. Наш курьер свяжется с Вами для уточнения адреса доставки карты. Спасибо ',
    courier_delivery_card_visa:
      'Наш курьер свяжется с вами для уточнения адреса доставки карты. Спасибо ',
    text: 'Текст ru',
    app_already_exist:
      'Упс, оказывается у вас уже есть карта «Салом». Скоро свяжемся с вами. Спасибо ',
  },
};

const reflect = {
  t: (text = 'text') => {
    if (reflect.lang !== 'tj' && reflect.lang !== 'ru') {
      reflect.lang = 'ru';
    }
    return translations[reflect.lang][text];
  },
  lang: 'ru',
};
export default reflect;
